/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inclusive_Green_Earthworm_GripInputs */

const fr_inclusive_green_earthworm_grip = /** @type {(inputs: Inclusive_Green_Earthworm_GripInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acheter`)
};

/**

* @param {Inclusive_Green_Earthworm_GripInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const inclusive_green_earthworm_grip = /** @type {((inputs?: Inclusive_Green_Earthworm_GripInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inclusive_Green_Earthworm_GripInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_inclusive_green_earthworm_grip(inputs)
});